import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

const Page = Scrivito.provideObjClass("Page", {
  attributes: {
    ...defaultPageAttributes,
    navigationIcon: "string",
    isNavigationPage: ["enum", { values: ["yes", "no"] }],
    ...metadataAttributes,
    logo: ["reference", { only: "Image" }],
  },
  extractTextAttributes: ["body", "title", "segmentName"],
});

export default Page;
